const aux = (props) => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/hoc/Auxilary/Auxilary.js